// @core/api/endpoints/legalentity/update_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LegalEntityResponse,
  UpdateLegalEntityRequest,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Update legal entity
 * Partially updates legal entity fields (use update_mask). Sets is_verified=false on changes to identifiers (tax IDs, registration number) — requires re-verification.
 */
export async function UpdateLegalEntity(
  legal_entity_id: string,
  data: UpdateLegalEntityRequest,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.patch<LegalEntityResponse>(requestPath, data, requestOptions);
}
